import React from 'react'
import './App.css' ;
import Clock1 from './components/Clock1';
import Clock2 from './components/Clock2';
import Clock3 from './components/Clock3';

function App() {
  return (
    <div className="App">
      <Clock1/>
      <Clock2/>
      <Clock3/>
    </div>
  );
}
export default App 